var _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumpsUpFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 19.248 20",
    width: 19.248,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.748 22.928h-3.529a1.218 1.218 0 0 1 -1.219-1.218v-10.664a1.218 1.218 0 0 1 1.219-1.218h3.529a1.218 1.218 0 0 1 1.218 1.217v.29a2.091 2.091 0 0 0 1.492-1.218l1.776-3.733a3.92 3.92 0 0 0 .342-1.141l.182-1.316a.6.6 0 0 1 .02-.087 1.289 1.289 0 0 1 1.255-.912h.075a2.753 2.753 0 0 1 1.967 1.255 3.858 3.858 0 0 1 .116 3.317 5.772 5.772 0 0 0 -.424 2.6 18.3 18.3 0 0 1 4.3.365h.033a2.313 2.313 0 0 1 .936.414 2.061 2.061 0 0 1 .154.121 2.234 2.234 0 0 1 .558 2.554 2.56 2.56 0 0 1 .5 1.387 2.664 2.664 0 0 1 -.609 1.758 2.68 2.68 0 0 1 -.792 2.977 2.657 2.657 0 0 1 -1.781 2.868 4.491 4.491 0 0 1 -1.812.361h-5.154a4.622 4.622 0 0 1 -2.38-.66l-.753-.445a1.218 1.218 0 0 1 -1.216 1.133zm0-1.712v.493s-2.848-3.578-2.848-6.244a15 15 0 0 1 .343-3.813l.18 1.907zm5.569-11.388 2.071-5.248a19.82 19.82 0 0 1 -.41 3.027l-1.662 9.309c-.438 1.025 2.81 1.617 1.712 1.81l-.709-.442-5.353 2.095 8.284-8.728c.529.318-1.677 5.051-1.059 5.052l1.422 4.513c-1.229-1.48-1.846-3.438-1.422-3.616.959-.421.628-.911 1.588.116-.017-.023-.257.277-.276.222-.085-.253-2.079-.862-1.866-1.022.718-.41 1.718-.441 1.327-1.169-.14-.234-.463-.492-.276-.69.336-.3.4.7.415.249-.029-.336 2.918-.8 2.681-1.043-.223-.2.572-.685.733-.937l.242.336-3.507 3.938 2.138-4.275a13.36 13.36 0 0 1 1.642 0l-4.841 7.891c-1.363-.276.228-5.8-1.162-5.752-.518 0 .237 3.324.123 2.82-.144-1.133-1.343 1.209-.912.151a6.494 6.494 0 0 0 .26-3.535s-1.536 4.2-.48 5.271-1.786-1.1-1.786-1.1 1.091-9.25 1.082-9.243zm-8.077 9.985a.743.743 0 1 1 .743.744.743.743 0 0 1 -.743-.744z",
    transform: "translate(0 -2.929)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e10092"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h27.553v27.044h-27.553z",
    transform: "translate(-5.909 -5.717)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1.327v1.327h-1.327z",
    transform: "translate(11.025 14.673)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 3.305,
    cy: 16.75,
    r: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumpsUpFilled);
export default __webpack_public_path__ + "static/media/thumps-up-filled.1bae6d655521265073bac7e8ac61c2b6.svg";
export { ForwardRef as ReactComponent };